__turbopack_context__.v({
  "back": "_5JyuG_back",
  "icon": "_5JyuG_icon",
});
